import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import _ from 'lodash';
import SalesCatalystChart from '../SalesCatalystCharts/SalesCatalystChart';
import * as salesCatalystActions from '../../../actions/salesCatalystActions';


class MediaBarChartPdf extends Component {
  constructor(props) {
    super(props);
    this.state = {
      setSelectedSlideIndex: 0,
      headerLabelTooltip: '',
    };
  }


  UNSAFE_componentWillReceiveProps(nextProps) {
    if (this.props.graphData !== nextProps.graphData) {
      this.setState({
        graphData: nextProps.graphData,
      });
    }
  }

  setChartSortInfo = sortInfo => {
    this.props.salesCatalystActions.setChartSortInfo(sortInfo);
  }


  renderBarGraph = (graphdata, index) => {
    const graphPdfHeader = this.props.graphPdfHeader(index, true);
    return (
      <div className="row pdf-charts">
        <div className="row pdf-charts scMediaPackage-imageBlock-header-pdf">
          <div className="row scMediaPackage-imageBlock-header-heading-pdf">
            {graphPdfHeader.label}</div></div>
        <div className="row">
          <SalesCatalystChart
            data={graphdata}
            message=""
            sortFn={this.setChartSortInfo}
            sortInfo={this.props.chartSortInfo}
            slideOrder="0"
            universityUser={this.props.universityUser}
            studyInfo={this.props.studyInfo}
          />
        </div>
        <div className="html2pdf__page-break">&nbsp;</div>
      </div>
    );
  }

  render() {
    const { graphData } = this.props;
    return (
      <div style={{ width: '68%' }}>
        {graphData !== undefined &&
          <div className="downloadSlide scMediaPackage-imageBlock-header-pdf pdf-charts downloadSlide-pdf" id="downloadSlide">
            {((!_.isEmpty(graphData.scTarget))
            && (this.props.graphData.scTarget.subEntities !== undefined)) &&
              <div className="large-12 medium-12 small-12 columns pdfGraphBlock pdf-charts">{this.renderBarGraph(graphData.scTarget, 0)}</div>
            }
            {((!_.isEmpty(graphData.scTargetEntity) &&
            this.props.graphData.scTargetEntity.subEntities !== undefined)) &&
              <div className="large-12 medium-12 small-12 columns pdf-charts">{this.renderBarGraph(graphData.scTargetEntity, 1)}</div>
            }
            {((!_.isEmpty(graphData.scTargetEntityBrand)) &&
             (this.props.graphData.scTargetEntityBrand.subEntities !== undefined)) &&
              <div className="large-12 medium-12 small-12 columns pdf-charts">{this.renderBarGraph(graphData.scTargetEntityBrand, 2)}</div>
            }
            {((!_.isEmpty(graphData.scTargetBrand)) &&
             (this.props.graphData.scTargetBrand.subEntities !== undefined)) &&
              <div className="large-12 medium-12 small-12 columns pdf-charts">{this.renderBarGraph(graphData.scTargetBrand, 3)}</div>
            } </div>
        }
      </div>
    );
  }
}

MediaBarChartPdf.propTypes = {
  download: PropTypes.func,
  universityUser: PropTypes.bool,
};


function mapStateToProps(state) {
  return {
    graphData: state.salesCatalyst.graphData,
    brand: state.salesCatalyst.dataSelection.brand,
    universityUser: state.login.loginResponse.data.universityUser || false,
    studyInfo: state.study.salesCatalystStudy
  };
}


function mapDispatchToProps(dispatch) {
  return {
    salesCatalystActions: bindActionCreators(salesCatalystActions, dispatch),

  };
}


export default connect(
  mapStateToProps,
  mapDispatchToProps,
  null,
  { forwardRef: true },
)(MediaBarChartPdf);
